<div class="bg-white dark:bg-gray-800 shadow-md rounded-lg px-6 py-4 relative" cdkTrapFocus>
  <button (click)="close()" class="absolute top-2 right-2 text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
  </button>
  <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4">
    Execution History
  </h3>
  <div class="overflow-x-auto">
    <table
      id="sorting-table"
      class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
    >
      <thead
        class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
      >
        <tr>
          <th class="px-4 py-2">Execution Time</th>
          <th class="px-4 py-2">Status</th>
          <th class="px-4 py-2">Execution Type</th>
          <th class="px-4 py-2">Duration (ms)</th>
          <th class="px-4 py-2">File Name (Parquet)</th>
          <th class="px-4 py-2">File Name (CSV)</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let execution of paginatedExecutions">
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <td
              class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {{ execution.last_exec | date : "HH:mm dd/MM/yyyy" }}
            </td>
            <td class="px-4 py-2">
              <span
                (click)="toggleError(execution)"
                [ngClass]="{
                  'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300':
                    execution.status === 'OK',
                  'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300 cursor-pointer':
                    execution.status === 'FAILED',
                  'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300':
                    execution.status === 'DEPRECATED',
                  'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300':
                    execution.status === null || execution.status === ''
                }"
                [title]="execution.status === 'DEPRECATED'
                  ? 'Ejecución conservada como historial. Sus archivos en MinIO ya fueron purgados por la política de retención (últimas 3 ejecuciones OK).'
                  : null"
                class="text-xs font-medium mr-2 px-2.5 py-0.5 rounded"
                >{{ execution.status || "NOT FOUND" }}</span
              >
            </td>
            <td class="px-4 py-2">
              <span
                [ngClass]="{
                  'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300':
                    execution.execution_type === 'AUTO',
                  'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300':
                    execution.execution_type === 'FORCE',
                  'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300':
                    execution.execution_type === 'INIT'
                }"
                class="text-xs font-medium mr-2 px-2.5 py-0.5 rounded"
                >{{ execution.execution_type || "NOT FOUND" }}</span
              >
            </td>
            <td class="px-4 py-2">
              {{ execution.processing_time_ms | miliSecondsConverter }}
            </td>
            <td class="px-4 py-2">{{ execution.object_name_parquet }}</td>
            <td class="px-4 py-2">{{ execution.object_name_csv }}</td>
          </tr>
          <tr *ngIf="expandedExecution === execution">
            <td colspan="6" class="p-2 bg-gray-50 dark:bg-gray-700/50">
              <pre
                class="text-xs text-gray-700 dark:text-gray-300 whitespace-pre-wrap p-2 rounded-md bg-gray-100 dark:bg-gray-800 max-h-40 overflow-auto"
                >{{ execution.error_message }}</pre
              >
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!allExecutions || allExecutions.length === 0">
          <td
            colspan="4"
            class="px-4 py-2 text-center text-gray-500 dark:text-gray-400"
          >
            No data available
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="flex justify-between items-center mt-4">
    <button
      (click)="previousPage()"
      [disabled]="currentPage === 1"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed">
      Previous
    </button>
    <span class="text-sm text-gray-700 dark:text-gray-200">
      Page {{ currentPage }} of {{ totalPages }}
    </span>
    <button
      (click)="nextPage()"
      [disabled]="currentPage * pageSize >= allExecutions.length"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed">
      Next
    </button>
  </div>
</div>
